import PropTypes from 'prop-types'
import {
  Container, Row, Col, Card,
} from 'react-bootstrap'

const Announcement = () => (
  <div className="h-100">
    <Container className="py-5 my-3">
      <Row>
        <Col>
          <Card className="announcement-card">
            <Card.Header>Pengumuman</Card.Header>
            <Card.Body>
              <Row>
                <Col>
                  <h4 className="text-center pb-5">Pemberitahuan Perubahan Alamat</h4>
                  <h5>
                    Yth. Saudara Pimpinan Penerbit /
                    <br />
                    Pelaku Perbukuan
                    <br />
                    di Tempat
                  </h5>
                  <div className="py-3 content-announcement">
                    <p className="mb-3">Dengan hormat, merujuk surat kami Nomor 2829/H4/PB.02/2021, tanggal 18 Agustus 2021 tentang pindah alamat kantor Pusat Kurikulum dan Perbukuan Badan Standar, Kurikulum, dan Asesmen Pendidikan Kemendikbudristek, kami perlu menyampaikan beberapa hal penting sebagai berikut.</p>
                    <ol className="pl-3">
                      <li>
                        <p>
                          Pusat Kurikulum dan Perbukuan Badan Standar, Kurikulum, dan Asesmen Pendidikan Kemendikbudristek, terhitung mulai bulan September 2021 menempati gedung baru yang beralamat: Kompleks Kemendikbudristek Gedung D Lantai 1,
                          JL. RS Fatmawati, Cipete, Jakarta 12410. Sehubungan dengan itu, Pusat Kurikulum dan Perbukuan mengharapkan kepada Saudara untuk mengirimkan fisik buku-buku nonteks pelajaran yang sudah dinyatakan layak dan telah ditetapkan melalui SK Kelayakan Tahun 2020 dengan jumah yang sesuai dengan ketentuan
                          per judulnya dan buku-buku yang telah didaftarkan secara online tahun 2021 sebanyak 2 eksemplar per judul dan lengkap identitas.
                        </p>
                      </li>
                      <li>
                        <p>
                          Kami minta agar fisik buku-buku nonteks pelajaran yang sudah dinyatakan layak dapat dikirimkan segera, terutama buku-buku yang telah didaftarkan pada tahun 2021, agar kami dapat segera memproses. Fisik buku-buku tersebut dapat kami terima paling lambat tanggal 15 Oktober 2021
                          (buku yang didaftarkan 2021 sampai dengan periode bulan Oktober 2021) dan tanggal 20 Oktober 2021 (contoh cetak buku yang sudah dinyatakan layak tahun 2020.
                        </p>
                      </li>
                      <li>
                        <p>
                          Penerbit yang memiliki kedua hal buku dimaksud, dalam proses pengiriman paket buku agar dapat dibedakan atau dipisah antara buku yang telah layak tahun 2020 dan buku yang didaftarkan di tahun 2021. Penerbit dapat memberi tanda pada paket pengiriman buku tersebut. Misalnya, Buku Contoh Cetak BNTP 2020 dan Daftar BNTP 2021.
                        </p>
                      </li>
                      <li>
                        <p className="mb-3">
                          Fisik buku sebagaimana yang dimaksud dalam poin 1, dapat dikirimkan segera secara langsung maupun melalui jasa pengiriman &gt; ke alamat:
                        </p>
                        <p className="font-weight-bold">
                          Sekretariat Panitia Penilaian Buku Nonteks Pelajaran
                          <br />
                          Pusat Kurikulum dan Perbukuan
                          <br />
                          Badan Standar, Kurikulum, dan Asesmen Pendidikan
                          <br />
                          Kementerian Pendidikan, Kebudayaan, Riset, dan Teknologi
                          <br />
                          Kompleks Kemendikbudristek Gedung D Lantai 1
                          <br />
                          JL. R.S. Fatmawati, Cipete, Jakarta 12410
                        </p>
                      </li>
                      <li>
                        <p>
                          Perlu kami ingatkan kembali kepada Saudara bahwa berdasarkan pengumuman pendaftaran penilaian buku nonteks pelajaran secara online tahun 2021 akan berakhir di bulan November 2021. Sehubungan dengan itu, kami akan menutup pendaftaran online
                          {' '}
                          <b>
                            pada tanggal 17 November 2021 pukul 24.00 WIB. Untuk kelancaran proses tahapan penilaian,
                            kami mengharapkan pengiriman fisik buku hasil pendaftaran paling lambat dapat kami terima tanggal 20 November 2021. Kami menghimbau kepada para penerbit/para pelaku perbukuan agar dapat segera dan secepatnyauntuk mendaftarkan buku nonteks pelajaran yang dimiliki secara online sebagaimana waktu yang telah ditentukan.
                          </b>
                        </p>
                      </li>
                    </ol>
                    <p className="font-weight-bold">Demikian informasi ini kami sampaikan, atas perhatian dan kerja sama yang baik, kami ucapkan terima kasih.</p>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  </div>
)

Announcement.propTypes = {

}

export default Announcement
